import { ref, computed, nextTick } from 'vue'

export function useOtpInput() {
    const otpDigits = ref<string[]>(['', '', '', '', '', ''])
    const otpRefs = ref<any[]>([])

    const otp = computed(() => otpDigits.value.join(''))

    const handlePaste = (event: ClipboardEvent, index: number) => {
        event.preventDefault()
        const paste = event.clipboardData?.getData('text')
        if (paste) {
            const digits = paste.replace(/\D/g, '').slice(0, 6).split('')
            otpDigits.value = digits.concat(['', '', '', '', '', '']).slice(0, 6)
            const nextIndex = Math.min(digits.length, 5)
            otpRefs.value[nextIndex]?.focus()
        }
    }

    const handleInput = (index: number) => {
        const value = otpDigits.value[index]
        if (typeof value === 'string' && value.length === 1 && index < 5) {
            otpRefs.value[index + 1]?.focus()
        }
    }

    const handleKeydown = (event: KeyboardEvent, index: number) => {
        if (event.key === 'Backspace' && !otpDigits.value[index] && index > 0) {
            otpRefs.value[index - 1]?.focus()
        }
    }

    const focusFirst = async () => {
        await nextTick()
        otpRefs.value[0]?.focus()
    }

    return {
        otpDigits,
        otpRefs,
        otp,
        handlePaste,
        handleInput,
        handleKeydown,
        focusFirst,
    }
}
